import { render, staticRenderFns } from "./NewContact.vue?vue&type=template&id=01814902&scoped=true"
import script from "./NewContact.vue?vue&type=script&lang=js"
export * from "./NewContact.vue?vue&type=script&lang=js"
import style0 from "./NewContact.vue?vue&type=style&index=0&id=01814902&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01814902",
  null
  
)

export default component.exports